import firebase from 'firebase/app';
import 'firebase/functions';
import { buildConfig } from '../config';

const config = buildConfig(process.env);

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebase);
}

if (config.firebase.functions.local) {
  firebase.functions().useEmulator(config.firebase.functions.host, config.firebase.functions.port);
}

const firestoreFunctions = firebase.functions();

export default class FunctionsService {
  functions: firebase.functions.Functions = firestoreFunctions;
}
